module.exports = __webpack_public_path__ + "img/business_01@2x.5db84a46.jpg";